import { message } from 'ant-design-vue';

export const oTool = {
    warningT(mess){
        message.warning(mess)
    },
    successT(mess = '操作成功',timeS,fn){
        message.success(mess,timeS,() => {
            fn();
        })
    }
}

export const oMath = {
    /**
     * 将小于10数字前加0
     *
     * @method _zeroCompletion
     * @param {Number} time 时间
     * @return {String}
     */
    _zeroCompletion (time) {
        if (time < 10) {
            return '0' + time;
        }
        return time + '';
    },
}

export const oDate = {
    /**
     * 将秒转换为时间hh:mm:ss格式
     *
     * @method secs2Time
     * @param {Number} secs 秒
     * @return {String} 格式化时间字符串'00:00:00'
     */
    secs2Time (secs) {
        if (secs < 0) {
            secs = 0;
        }
        secs = parseInt(secs, 10);
        var hours = Math.floor(secs / 3600),
        mins = Math.floor((secs % 3600) / 60),
        sec = secs % 3600 % 60;
        return oMath._zeroCompletion(hours) + ':' + oMath._zeroCompletion(mins) + ':' + oMath._zeroCompletion(sec);
    },
    /**
     * 将日期格式转换为时间yy-mm-dd hh:mm格式
     *
     * @method secs2Time
     * @param {Number} 日期格式
     * @return {String} 格式化时间字符串'2018-01-01 00:00'
     */
    secsTime (today) {
        if(!today){return ''}
        var month = today.getMonth() + 1;
        month = month < 10 ? '0'+month : month;
        var day = today.getDate() < 10 ? '0'+today.getDate() : today.getDate();
        var hours = today.getHours() < 10 ? '0'+today.getHours() : today.getHours();
        var mins = today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes();
        return today.getFullYear() + '-' + month + '-' + day + ' ' + hours + ":" + mins ;
    },
    /**
     * 将日期格式转换为时间yy-mm-dd格式
     *
     * @method secs2Time
     * @param {Number} 日期格式
     * @return {String} 格式化时间字符串'2018-01-01'
     */
    secsTime3 (today) {
        if(!today){return ''}
        console.log(today)
        var month = today.getMonth() + 1;
        month = month < 10 ? '0'+month : month;
        var day = today.getDate() < 10 ? '0'+today.getDate() : today.getDate();
        return today.getFullYear() + '-' + month + '-' + day;
    },
    /**
     * 项目专用 后台时间 转秒
     * @method getTime
     * @param {*} secs 秒
     */
    getTime (time) {
        let timeArr = (time + '').split('.');
        let timeNumber = (timeArr[0]*60 + (timeArr[1] ? Number(timeArr[1]) : 0)) * 60;
        return timeNumber
    }
}

// export const numDate = {
	/**
	 * 判斷輸入的是否是數據類型 
	 */
const isnumdate=(data,Fixed)=>{
	// console.log(Number(data))
		if(String(Number(data)) == 'NaN'){
			return ''
		}else{
			if(Fixed){
				if(Number(data).toFixed(2)>0){
					return Number(data).toFixed(2)
				}else{
					return ''
					}
			}else{
				return data
			}
		}
	}
// }
export default {
    oTool,
    oMath,
    oDate,
	isnumdate
}




// WEBPACK FOOTER //
// ./src/assets/app.js